if (!customElements.get('toast-notification')) {
  class ToastNotification extends HTMLElement {
    constructor() {
      super();

      this.handleShowRef = this.handleShow.bind(this);
    }

    handleShow(event) {
      this.innerHTML = event.detail.text;

      this.classList.add('is-visible');

      setTimeout(() => {
        this.classList.remove('is-visible');
      }, 2000);
    }

    disconnectedCallback() {
      document.removeEventListener('toast:show', this.handleShowRef);
    }

    connectedCallback() {
      document.addEventListener('toast:show', this.handleShowRef);
    }
  }

  customElements.define('toast-notification', ToastNotification);
}
